/**
 * Group a list of items by doctorId, preserving first-appearance order. Items missing a doctorId
 * go into a final group keyed by null (rendered as "—" by callers).
 */
export interface DoctorGroup<T> {
    doctorId: number | null;
    doctorName: string;
    items: T[];
}

export function groupByDoctor<T extends { doctorId?: number; doctorName?: string }>(items: T[]): DoctorGroup<T>[] {
    const order: (number | null)[] = [];
    const map = new Map<number | null, DoctorGroup<T>>();
    for (const it of items) {
        const key = it.doctorId ?? null;
        if (!map.has(key)) {
            map.set(key, {
                doctorId: key,
                doctorName: (it.doctorName ?? '').trim() || '—',
                items: [],
            });
            order.push(key);
        }
        map.get(key)!.items.push(it);
    }
    return order.map((k) => map.get(k)!);
}
